import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loading = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        height: '100vh',      // full screen height
        justifyContent: 'center', // horizontal centering
        alignItems: 'center'      // vertical centering
      }}
    >
      <CircularProgress size="5em" />
    </Box>
  );
}

export default Loading;
